<template>
  <v-list-item
		:two-line="titulo && subtitulo ? true : undefined"
		v-bind="$attrs"
		v-on="$listeners"
	>
    <v-list-item-avatar>
			<slot name="avatar">
      	<v-icon>{{ icone }}</v-icon>
			</slot>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-subtitle> {{ subtitulo }}</v-list-item-subtitle>
      <v-list-item-title>
				<slot name="titulo">
					<component :is="href ? 'a' : 'div'" :href="href">
						{{ titulo }}
					</component>
				</slot>
			</v-list-item-title>
    </v-list-item-content>
		<slot name="actions"/>
  </v-list-item>
</template>

<script lang="ts">
export default {
	inheritAttrs: false,
}
</script>

<script setup lang="ts">
defineProps({
	icone: { default: undefined, type: String },
	titulo: { default: undefined, type: [String, Number] },
	subtitulo: { default: undefined, type: [String, Number] },
	href: { default: undefined, type: String },
})
</script>
